<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
          My Pending Approvals</h5>
      </div>
<div id="mainContent" class="container">
  <div class="" *ngIf="!showDiaryApprovalDetails && !showLeaveApprovalDetails">
    <div class="row pt-3">
      <div class="col-md-12" style="text-align: center">
        <span class="bg-theme-title">My Pending Diary Approvals</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th></th>
              <th>Employee</th>
              <th>Week Start Date</th>
              <th>Week End Date</th>
              <th>Week Of Year</th>
              <th>Status</th>
              <th>Diary Submitted Date</th>
              <th>Diary Approval Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let approval of pendingDiaryApprovalList; index as i"
              id="pendingDiaryApproval_{{ i + 1 }}"
            >
              <td>
                <!-- <button
                  id="viewDiaryDetailsBtn_{{ i + 1 }}"
                  name="viewDiaryDetailsBtn_{{ i + 1 }}"
                  class="btn btn-link btn-xs"
                  style="padding: 2px"
                  (click)="viewDiaryDetails(approval)"
                  matTooltip="Click to submit"
                  matTooltipPosition="above">
                  <span style="color:#800000; cursor: pointer;text-decoration: underline;" > View Details </span>
                </button> -->
                <a (click)="viewDiaryDetails(approval)" style="color:#800000; cursor: pointer;text-decoration: underline;">View Details</a>
              </td>
              <td>{{ approval.employeeName }}</td>
              <td>{{ approval.weekStartDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approval.weekEndDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approval.weekOfYear }}</td>
              <td>{{ approval.status }}</td>
              <td>{{ approval.submittedDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approval.approvalDate | date: "dd-MMM-yyyy" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12" style="text-align: center">
        <span class="bg-theme-title">My Pending Leave Approvals</span>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-md-12">
        <table class="table table-sm table-bordered table-striped">
          <thead class="">
            <tr>
              <th></th>
              <th>Employee Name</th>
              <th>Leave Start Date</th>
              <th>Leave End Date</th>
              <th>Leave Type</th>
              <th>Submitted Date</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let pendingLeave of pendingLeaveApprovalList; index as i"
              id="pendingLeaveApproval_{{ i + 1 }}"
            >
              <td>
                <!-- <button
                  id="viewLeaveDetailsBtn_{{ i + 1 }}"
                  name="viewLeaveDetailsBtn_{{ i + 1 }}"
                  class="btn btn-link btn-xs"
                  style="padding: 2px"
                  matTooltip="Click to submit"
                  matTooltipPosition="above"
                  (click)="viewLeaveDetails(pendingLeave)"
                >
                <span style="color:#800000; cursor: pointer;text-decoration: underline;" > View Details</span>
                </button> -->
                <a (click)="viewLeaveDetails(pendingLeave)" style="color:#800000; cursor: pointer;text-decoration: underline;">View Details</a>
              </td>
              <td>
                {{ pendingLeave.user.firstName }}
                {{ pendingLeave.user.lastName }}
              </td>
              <td>{{ pendingLeave.fromDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ pendingLeave.toDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ pendingLeave.leaveType.name }}</td>
              <td>{{ pendingLeave.createdDate | date: "dd-MMM-yyyy" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div
    class=""
    *ngIf="showDiaryApprovalDetails"
  >
  <br/>
    <div class="row">
      <div class="col-md-4">
        <button
          class="btn btn-xs btn-theme"
          style="float: left"
          matTooltip="Click to add"
          matTooltipPosition="left"
          (click)="showDiaryApprovalDetails = false"
          (click)="loadPendingDiaryApproval()"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;Back
        </button>
      </div>
      <div class="col-md-4" style="text-align: center">
        <span class="bg-theme-title">Diary Approval Management</span>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <label>Start Date :</label>
        {{ selectedEmployee.weekStartDate | date: "dd-MMM-yyyy" }}
      </div>
      <div class="col-md-12">
        <label>Week End Date :</label>
        {{ selectedEmployee.weekEndDate | date: "dd-MMM-yyyy" }}
      </div>
      <div class="col-md-12">
        <label>Employee Name :</label> {{ selectedEmployee.employeeName }}
      </div>
    </div>

    <div class="row ">
      <div class="col-md-12">
        <table class="table table-sm table-bordered table-striped"  style="display: block; overflow-x: auto; white-space: nowrap">
          <thead>
            <tr>
              <th rowspan="2"></th>
              <th rowspan="2"></th>
              <th rowspan="2">Status</th>
              <th rowspan="2">ApproverName</th>
              <th rowspan="2">Date</th>
              <th rowspan="2">Day</th>
              <th rowspan="2">ClientName</th>
              <th rowspan="2">Assignment</th>
              <th rowspan="2">AsgForFy</th>
              <th rowspan="2">Task</th>
              <th rowspan="2">WorkPerformed</th>
              <th colspan="2">Time</th>
              <th rowspan="2">No.of.Hours</th>
              <th rowspan="2">Extra/ShortHours</th>
              <th colspan="2">Time</th>
              <th rowspan="2">DistanceInKms</th>
              <th rowspan="2">Mode</th>
              <th rowspan="2">TravellingFrom</th>
              <th rowspan="2">Rate</th>
              <th rowspan="2">Amount</th>
              <th rowspan="2">ChargableToClients</th>
            </tr>
            <tr>
              <th>In</th>
              <th>Out</th>
              <th>Dr</th>
              <th>Cr</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let approvalDetails of pendingDiaryApprovalDetails;
                index as i
              "
              id="pendingDiaryApprovalDetail_{{ i + 1 }}"
            >
              <td>
                <button
                  id="approveDiaryBtn_{{ i + 1 }}"
                  name="approveDiaryBtn_{{ i + 1 }}"
                  class="btn btn-xs"
                  style="padding: 2px"
                  matTooltip="Click to submit"
                  matTooltipPosition="above"
                  [disabled]="
                    approvalDetails.status == 'Approved' ||
                    approvalDetails.status == 'Resent'
                  "
                  (click)="approveDiary(approvalDetails)"
                >
                <span style="color:#800000; cursor: pointer;"> Approve</span>
                </button>
              </td>
              <td>
                <button
                  id="resendDiaryBtn_{{ i + 1 }}"
                  name="resendDiaryBtn_{{ i + 1 }}"
                  class="btn btn-xs"
                  style="padding: 2px"
                  matTooltip="Click to submit"
                  matTooltipPosition="above"
                  [disabled]="
                    approvalDetails.status == 'Approved' ||
                    approvalDetails.status == 'Resent'
                  "
                  (click)="openDialogDiaryResend(approvalDetails)"
                >
                  <span style="color:#800000; cursor: pointer;">Resend</span> 
                </button>
              </td>
              <td>{{ approvalDetails.status }}</td>
              <td>
                {{ approvalDetails.approver.firstName }}
                {{ approvalDetails.approver.lastName }}
              </td>
              <td>{{ approvalDetails.entryDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approvalDetails.entryDate | date: "EEEE" }}</td>
              <td>{{ approvalDetails.client.name }}</td>
              <td>{{ approvalDetails.assignment.name }}</td>
              <td>{{ approvalDetails.assignmentFY }}</td>
              <td>{{ approvalDetails.task.name }}</td>
              <td>{{ approvalDetails.workPerformed }}</td>
              <td>
                {{ approvalDetails.inTimeHour }}.{{ approvalDetails.inTimeMin }}
              </td>
              <td>
                {{ approvalDetails.outTimeHour }}.{{
                  approvalDetails.outTimeMin
                }}
              </td>
              <td>
                {{ approvalDetails.noOfTimeHours }}.{{
                  approvalDetails.noOfTimeMin
                }}
              </td>
              <td>
                {{ approvalDetails.extraTimeHours }}.{{
                  approvalDetails.extraTimeMin
                }}
              </td>
              <td>
                {{ approvalDetails.debitedTimeHours }}.{{
                  approvalDetails.debitedTimeMin
                }}
              </td>
              <td>
                {{ approvalDetails.creditedTimeHours }}.{{
                  approvalDetails.creditedTimeMin
                }}
              </td>
              <td>{{ approvalDetails.distanceFromOffice }}</td>
              <td>{{ approvalDetails.mode }}</td>
              <td>{{ approvalDetails.travellingFrom }}</td>
              <td>{{ approvalDetails.rate }}</td>
              <td>{{ approvalDetails.amount }}</td>
              <td>
                <span *ngIf="approvalDetails.chargeableToClient">Yes</span>
                <span *ngIf="!approvalDetails.chargeableToClient">No</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2">
        <button
          id="approveAllBtn"
          name="approveAllBtn"
          class="btn btn-xs btn-theme"
          style="float: left"
          matTooltip="Click to submit all"
          matTooltipPosition="left"
          (click)="approveAllDiary()"
        >
          <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Approve All
        </button>
      </div>
    </div>
    <br/>
  </div>

  <div
    class=""
    *ngIf="showLeaveApprovalDetails"
  >
    <div class="row pt-3">
      <div class="col-md-4">
        <button
          class="btn btn-xs btn-theme "
          style="float: left"
          matTooltip="Click to add"
          matTooltipPosition="left"
          (click)="showLeaveApprovalDetails = false"
        >
          <i class="fa fa-arrow-left" aria-hidden="true"></i>&nbsp;Back
        </button>
      </div>
      <div class="col-md-4" style="text-align: center">
        <span class="bg-theme-title">Leave Approval Management</span>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-12">
        <label>Leave Applied By :</label>
        {{ selectedEmployeeForLeave.user.firstName }}
        {{ selectedEmployeeForLeave.user.lastName }}
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th>Leave From Date</th>
              <th>Leave To Date</th>
              <th>Total Days</th>
              <th>Leave Type</th>
              <th>Available Leaves</th>
              <th>Reason</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr id="leaveDetail">
              <td>{{ leaveApprovalDetails.fromDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ leaveApprovalDetails.toDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ leaveApprovalDetails.leaveDays }}</td>
              <td>{{ leaveApprovalDetails.leaveType.name }}</td>
              <td>{{ leaveApprovalDetails.pendingLeaves }}</td>
              <td>{{ leaveApprovalDetails.reason }}</td>
              <td>{{ leaveApprovalDetails.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-1">
        <button
          class="btn btn-xs btn-theme"
          style="float: left"
          matTooltip="Click to approve"
          matTooltipPosition="above"
          (click)="changeLeaveStatus('Approved')"
        >
          Approve
        </button>
      </div>
      <div class="col-md-1">
        <button
          class="btn btn-xs btn-theme"
          style="float: left"
          matTooltip="Click to resend"
          matTooltipPosition="above"
          (click)="openDialog()"
        >
          Resend
        </button>
      </div>
    </div>
    <br/>
    <div class="row">
      <div class="col-md-12">
        <label>Leave Details Of :</label>
        {{ selectedEmployeeForLeave.user.firstName }}
        {{ selectedEmployeeForLeave.user.lastName }}
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <table class="table table-bordered table-striped table-sm">
          <thead class="">
            <tr>
              <th>Sr.No.</th>
              <th>Approver Name</th>
              <th>From Date</th>
              <th>To Date</th>
              <th>Number Of Days</th>
              <th>Leave Type</th>
              <th>Leave Request Date</th>
              <!-- <th>Balance</th> -->
              <th>Reason</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let approver of appliedLeavesList; index as i"
              id="approver_{{ i + 1 }}"
            >
              <td scope="row">{{ i + 1 }}</td>
              <td *ngIf="approver.approver !=null">
                {{ approver.approver.firstName }}
                {{ approver.approver.lastName }}
              </td>
              <td>{{ approver.fromDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approver.toDate | date: "dd-MMM-yyyy" }}</td>
              <td>{{ approver.leaveDays }}</td>
              <td>{{ approver.leaveType.name }}</td>
              <td>{{ approver.createdDate | date: "dd-MMM-yyyy" }}</td>
              <!-- <td></td> -->
              <td>{{ approver.reason }}</td>
              <td>{{ approver.status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
</div>
